import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BASE_URL} from "../../app.environment";
import {Make} from "../types/makes/types";

@Injectable({
    providedIn: 'root'
})
export class MakeService {
    httpClient = inject(HttpClient)
    baseApiUrl = BASE_URL;
    protected imageIdToApproveAllMakes: number | undefined;
    protected sjcGroupIdToApproveAllMakes: number | undefined;
    protected sjcIdToApproveAllMakes: number | undefined;
    protected makeIdToApproveAllMakes: number | undefined;

    constructor() {
    }

    getMakes() {
        return this.httpClient.get<Make[]>(`${this.baseApiUrl}/makes`)
        // return MAKES_MOCK
    }

    setImageToApprove(imageId: number, sjcGroupId: number, sjcId: number | undefined = undefined, makeId: number) {
        this.imageIdToApproveAllMakes = imageId;
        this.sjcGroupIdToApproveAllMakes = sjcGroupId;
        this.sjcIdToApproveAllMakes = sjcId;
        this.makeIdToApproveAllMakes = makeId
    }

    approveForAllMakes() {
        if (!this.imageIdToApproveAllMakes) {
            return
        }

        const body = {
            image_id: this.imageIdToApproveAllMakes,
            sjc_group_id: this.sjcGroupIdToApproveAllMakes,
            sjc_id: this.sjcIdToApproveAllMakes,
            make_id: this.makeIdToApproveAllMakes
        }

        return this.httpClient.post(`${this.baseApiUrl}/approve_all_makes`, body)
    }


}
